export const AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT = 'aud_desktop_aud2776_cian_assistant_entry_point';

export const EXPERIMENTS = [AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT];
